// removed by extract-text-webpack-plugin
module.exports = {"border-color":"#969696","table-row-highlight-color":"#D4E7FC","input-width":"35rem","container":"_2ChRnm83_VI5q_DFjCcgdN","input":"_370P00t6D2z4erykCRVotq","inputFocused":"_3Nq_R6p7ax8tGAJhZAkrhn","inputOpen":"_1VPGC7f2M3X0pQDvyJcqa3","suggestionsContainer":"_2QB3BWf-xFzdpYecSF3NvQ","suggestionsContainerOpen":"_35mCRCAU-76yuCTYNLy6v0","suggestionsList":"_12idK937kFv6uIfjKt8a-6","suggestion":"_13kN-8UZMEZt4Mm8j1-odP","suggestionHighlighted":"_1hmziMgjESjos9WvXos0f"};


//////////////////
// WEBPACK FOOTER
// ./src/views/fragments/forms/autosuggest-theme.css
// module id = 731
// module chunks = 0